var React = require('react');

function Print (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M80 54h97v70H80z M24 123h208v92H24z","fill":"#FFF","stroke":"#2F73A7","strokeWidth":"10","key":0}),React.createElement("circle",{"cx":"202","cy":"154","fill":"#C13CCD","r":"13","key":1})]);
}

Print.defaultProps = {"viewBox":"0 0 256 256","width":"32"};

module.exports = Print;

Print.default = Print;
